import {MyAccountInitialState, MyAccountActionTypes} from './myaccount-types';

import {
  defaultActiveTab,
  TRIP_HEADERS,
  UPDATE_MYTRIP_LOADER,
  UPDATE_MYTRIP_ACTIVE_TAB,
  UPDATE_MYTRIP_HEADERS,
  UPDATE_MYTRIP_DATA,
  UPDATE_MYTRIP_DETAILS_QUERY_PARAMS,
  UPDATE_MYTRIP_DETAILS_DATA,
  UPDATE_CANCELLATION_DATA,
  UPDATE_CANCELLATION_ACTIVE_TAB,
  UPDATE_CANCELLATION_REFUND_MODE,
  UPDATE_CANCELLATION_REFUND_DATA,
  UPDATE_WALLET_DATA,
  UPDATE_WALLET_STATEMENT_LOADER,
  UPDATE_WALLET_BREAKUP_DATA,
  UPDATE_RECHARGE_STATUS,
  UPDATE_MODIFY_ACTIVE_TAB,
  UPDATE_MODIFY_HOTEL_DETAILS_DATA,
  UPDATE_MODIFY_DETAILS_DATA,
  UPDATE_MODIFY_STATUS,
  UPDATE_USER_SETTING_DATA,
  UPDATE_SUCCESS_NAME_MESSAGE,
  UPDATE_ERROR_NAME_MESSAGE,
  UPDATE_AADHAR_NUMBER,
  UPDATE_WALLET_TYPE,
  UPDATE_NEFT_DETAILS,
  UPDATE_NEFT_DETAILS_LOADER,
  UPDATE_LOYALTY_AGREEMENT_DATE,
  UPDATE_LOYALTY_AGREEMENT_DOC,
  UPDATE_GCC_USER_SETTING_DATA,
  UPDATE_FORMFIELD_DATA,
  UPDATE_ROW_FIELDS_DATA,
  UPDATE_CARDS_MEMO,
  UPDATE_CARDS_DATA,
  UPDATE_AIS_CARDS_DATA,
  UPDATE_GST_FORM_ROW,
} from './myaccount-constants';

const initialState: MyAccountInitialState = {
  headers: TRIP_HEADERS,
  loading: true,
  activeTab: defaultActiveTab,
  myTripBookings: {},
  userDetails: {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    date_joined: null,
  },
  detailsParams: {
    parentID: '',
    childID: '',
    mobile: '',
  },
  myTripBookingDetails: {},
  myTripPaymentDetails: {},
  cancellationData: {},
  activeCancellationTab: 'refund',
  selectedRefundMode: 'wallet',
  refundData: {},
  statementLoader: true,
  walletData: [],
  walletBreakup: {},
  rechargeStatus: null,
  activeModifyTab: 'details',
  modifyHotelData: null,
  modifyDetails: {},
  modifyStatus: null,
  updateUserSetting: {},
  nameChangeMessage: '',
  errorNameChangeMsg: '',
  aadharData: {},
  walletType: 'wallet',
  loyaltyAgreementDate: {},
  updateGccUserSetting: null,
  formFieldData: {},
  rowFieldsData: {},
  showCardsMemo: {},
  aisCards: {},
  editGstFormRow: {},
};

export default function myAccountReducer(state = initialState, action: MyAccountActionTypes) {
  switch (action.type) {
    case UPDATE_MYTRIP_LOADER:
      return {
        ...state,
        loading: action.actionData,
      };

    case UPDATE_MYTRIP_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.actionData,
      };

    case UPDATE_MYTRIP_HEADERS:
      return {
        ...state,
        headers: action.actionData,
      };

    case UPDATE_MYTRIP_DATA:
      return {
        ...state,
        myTripBookings: action.actionData.bookings,
        userDetails: action.actionData.user_details,
        loading: action.actionData.loading,
      };

    case UPDATE_MYTRIP_DETAILS_QUERY_PARAMS:
      return {
        ...state,
        detailsParams: action.actionData,
      };

    case UPDATE_MYTRIP_DETAILS_DATA:
      return {
        ...state,
        myTripBookingDetails: action.actionData.trip_detail.booking_detail,
        myTripPaymentDetails: action.actionData.trip_detail.payment_detail,
        loading: action.actionData.loading,
      };

    case UPDATE_CANCELLATION_DATA:
      return {
        ...state,
        cancellationData: action.actionData.data,
        loading: action.actionData.loading,
      };

    case UPDATE_CANCELLATION_ACTIVE_TAB:
      return {
        ...state,
        activeCancellationTab: action.actionData,
      };

    case UPDATE_CANCELLATION_REFUND_MODE:
      return {
        ...state,
        selectedRefundMode: action.actionData,
      };

    case UPDATE_CANCELLATION_REFUND_DATA:
      return {
        ...state,
        refundData: action.actionData.refundData,
        loading: action.actionData.loading,
      };

    case UPDATE_WALLET_DATA:
      return {
        ...state,
        statementLoader: false,
        walletData: action.actionData.walletData,
      };

    case UPDATE_WALLET_STATEMENT_LOADER:
      return {
        ...state,
        walletData: [],
        statementLoader: action.actionData,
      };

    case UPDATE_WALLET_BREAKUP_DATA:
      return {
        ...state,
        walletBreakup: action.actionData.walletBreakupData,
      };

    case UPDATE_RECHARGE_STATUS:
      return {
        ...state,
        rechargeStatus: action.actionData,
      };

    case UPDATE_MODIFY_ACTIVE_TAB:
      return {
        ...state,
        activeModifyTab: action.actionData,
      };

    case UPDATE_MODIFY_HOTEL_DETAILS_DATA:
      return {
        ...state,
        modifyHotelData: action.actionData,
        loading: false,
      };

    case UPDATE_MODIFY_DETAILS_DATA:
      return {
        ...state,
        activeModifyTab: 'cost',
        modifyDetails: action.actionData,
      };

    case UPDATE_MODIFY_STATUS:
      return {
        ...state,
        modifyStatus: action.actionData,
      };

    case UPDATE_USER_SETTING_DATA:
      return {
        ...state,
        updateUserSetting: action.actionData,
      };

    case UPDATE_GCC_USER_SETTING_DATA:
      return {
        ...state,
        updateGccUserSetting: action.actionData,
      };

    case UPDATE_SUCCESS_NAME_MESSAGE:
      return {
        ...state,
        nameChangeMessage: action.actionData,
      };

    case UPDATE_ERROR_NAME_MESSAGE:
      return {
        ...state,
        errorNameChangeMsg: action.actionData,
      };

    case UPDATE_AADHAR_NUMBER:
      return {
        ...state,
        aadharData: action.actionData,
      };
    case UPDATE_WALLET_TYPE:
      return {
        ...state,
        walletType: action.actionData?.toLowerCase(),
      };

    case UPDATE_NEFT_DETAILS:
      return {
        ...state,
        neftDetails: action.actionData,
      };

    case UPDATE_NEFT_DETAILS_LOADER:
      return {
        ...state,
        loadingNeft: action.actionData,
      };

    case UPDATE_LOYALTY_AGREEMENT_DATE:
      return {
        ...state,
        loyaltyAgreementDate: action.actionData,
      };

    case UPDATE_LOYALTY_AGREEMENT_DOC:
      return {
        ...state,
        loyaltyAgreementDoc: action.actionData,
      };

    case UPDATE_FORMFIELD_DATA:
      return {
        ...state,
        formFieldData: {...state.formFieldData, ...action.actionData},
      };

    case UPDATE_ROW_FIELDS_DATA:
      return {
        ...state,
        rowFieldsData: action.actionData,
      };

    case UPDATE_CARDS_MEMO:
      return {
        ...state,
        showCardsMemo: action.actionData,
      };

    case UPDATE_CARDS_DATA:
      return {
        ...state,
        aisCards: action.actionData,
      };

    case UPDATE_AIS_CARDS_DATA:
      return {
        ...state,
        aisCards: action.actionData,
      };

    case UPDATE_GST_FORM_ROW:
      return {
        ...state,
        editGstFormRow: action.actionData,
      };

    default:
      return state;
  }
}
